<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'LICENSE_CATEGORIES', url: '/admin/license-categories' },
    {
      label: 'LICENSE_CATEGORY',
      url: ['/admin/license-categories', businessCategoryId, 'update']
    },
    { label: 'UPDATE_LICENSE_SUBCATEGORY' }
  ]"
></breadcrumbs>

<page-header
  title="{{ 'UPDATE_LICENSE_SUBCATEGORY' | translate }}"
></page-header>
<content-loading
  *ngIf="!(types?.length && calculationTypes?.length && getField(['id']))"
></content-loading>
<ng-container
  *ngIf="types?.length && calculationTypes?.length && getField(['id'])"
>
  <card>
    <form class="form" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="NAME">{{
          'NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="SUBCATEGORY_TYPE">{{
          'SUBCATEGORY_TYPE' | translate
        }}</label>
        <div class="control">
          <select
            [translationEditableModalDirective]="typesTranslateKeys"
            [translationEditableModalDirectiveDefaults]="typesTranslateDefaults"
            name="subCategoryType"
            class="input is-small"
            (change)="handleFieldChange($event)"
          >
            <option value="">{{ 'SUBCATEGORY_TYPE' | translate }}</option>
            <option
              *ngFor="let type of types"
              [selected]="getField(['subCategoryType']) === type.name"
              [value]="type.name"
            >
              {{ type.trnKey | translate : { defaultValue: type.defaultName } }}
            </option>
          </select>
        </div>
        <p class="help is-danger" *ngIf="hasError('subCategoryType')">
          {{ getError('subCategoryType') }}
        </p>
      </div>

      <div class="field is-narrow" *ngIf="!isFixedType">
        <label class="label" translationEditableDirective="PROPERTY_TYPE">{{
          'PROPERTY_TYPE' | translate
        }}</label>
        <div class="control is-relative">
          <input
            class="input is-small"
            name="propertyType"
            readonly
            type="text"
            [value]="getField(['propertyType'])"
            [ngClass]="{ 'is-danger': hasError('propertyType') }"
            style="cursor: default"
          />
          <button
            class="button p-1"
            type="button"
            (click)="isPropertyTypesOpen = true"
            style="
              position: absolute;
              top: 0px;
              right: 8px;
              height: auto;
              border: 0;
              background: transparent;
              outline: none !important;
              box-shadow: none !important;
            "
          >
            <span class="icon is-small">
              <i class="fa-regular fa-pen-to-square"></i>
            </span>
          </button>
        </div>
        <p class="help is-danger" *ngIf="hasError('propertyType')">
          {{ getError('propertyType') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="TEMPLATE">{{
          'TEMPLATE' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="templates"
            name="template"
            [multiple]="false"
            [closeOnSelect]="true"
            [ngClass]="{ 'is-danger': hasError('template') }"
            bindLabel="name"
            bindValue="id"
            [typeahead]="onTemplateAutocomplete$"
            (change)="handleFieldChange($event, 'template')"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['template', 'id'])"
            class="is-small"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('template')">
          {{ getError('template') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="PENALTY_PERCENTAGE">
          {{ 'PENALTY_PERCENTAGE' | translate }}
        </label>
        <div class="control has-icons-right">
          <number-input
            name="penaltyPercentage"
            (input)="handleFieldChange($event)"
            [value]="getField(['penaltyPercentage'])"
            [inputClass]="{
              'is-danger': hasError('penaltyPercentage'),
              'input is-small': true
            }"
          />
          <span class="icon is-small is-right"> % </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('penaltyPercentage')">
          {{ getError('penaltyPercentage') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="MIN_TAX">
          {{ 'MIN_TAX' | translate }}
        </label>
        <div class="control">
          <number-input
            name="minTax"
            (input)="handleFieldChange($event)"
            [value]="getField(['minTax'])"
            [inputClass]="{
              'is-danger': hasError('minTax'),
              'input is-small': true
            }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('minTax')">
          {{ getError('minTax') }}
        </p>
      </div>

      <business-subcategory-slots
        (rowAdd)="rowAdd()"
        (rowDelete)="rowDelete($event)"
        [data]="state.getIn(['data', 'logicSlots'])"
        (fieldChange)="handleFieldChange($event.e, null, $event.row)"
        [calculationTypes]="calculationTypesBySubcategoryType"
        [errors]="errors"
      ></business-subcategory-slots>
    </form>
  </card>
  <div class="field is-grouped px-3">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-success"
        (click)="onSubmit($event)"
        translationEditableDirective="SUBMIT"
      >
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
    <div class="control">
      <a
        [routerLink]="[
          '/admin/license-categories',
          businessCategoryId,
          'update'
        ]"
        class="button is-link is-light"
        translationEditableDirective="CANCEL"
        >{{ 'CANCEL' | translate }}</a
      >
    </div>
  </div>

  <property-type-modal
    (onClose)="isPropertyTypesOpen = false"
    (onSave)="handleFieldChange($event, 'propertyType')"
    [isOpen]="isPropertyTypesOpen"
  ></property-type-modal>
</ng-container>
